export default __webpack_public_path__ + "static/media/icon_locations.c5d7e6a8.svg";